import React from "react";
import { Link } from "react-router-dom";

const WORK_COPY = {
  en: {
    title: "How Best Place helps you launch a QR menu",
    intro:
      "Best Place is built so a restaurant can start a digital menu without unnecessary technical confusion. You add information about the restaurant, create the menu, fill in categories and items, add photos, prices, and descriptions. After that, you receive a QR code that leads to your menu.",
    steps: [
      "Create your restaurant profile",
      "Add menu categories",
      "Add dishes, photos, descriptions",
      "Generate a QR code",
      "Assistance at all stages",
    ],
    firstText:
      "From there, the process is simple: test the menu on a smartphone, print the QR code for tables or table tents, and use it in the restaurant. When something changes, you update it in the admin panel.",
    secondText:
      "You do not need to contact a designer or developer every time a price changes, a new dish appears, or one item has to be hidden for a while. For a restaurant, this is probably one of the biggest practical advantages: the menu stays alive.",
    demo: "WATCH DEMO",
    register: "TRY FOR FREE",
    navLabel: "Next steps",
  },

  de: {
    title: "Wie Best Place Ihnen beim Start einer QR-Code-Speisekarte hilft",
    intro:
      "Best Place ist so aufgebaut, dass ein Restaurant ohne unnötige technische Verwirrung mit einer digitalen Speisekarte starten kann. Sie fügen Informationen über Ihr Restaurant hinzu, erstellen die Speisekarte, legen Kategorien und Produkte an, ergänzen Fotos, Preise und Beschreibungen. Danach erhalten Sie einen QR-Code, der direkt zu Ihrer Speisekarte führt.",
    steps: [
      "Restaurantprofil erstellen",
      "Speisekarten-Kategorien hinzufügen",
      "Gerichte, Fotos und Beschreibungen hinzufügen",
      "QR-Code generieren",
      "Unterstützung in allen Phasen",
    ],
    firstText:
      "Danach ist der Ablauf einfach: Testen Sie die Speisekarte auf einem Smartphone, drucken Sie den QR-Code für Tische oder Tischaufsteller aus und nutzen Sie ihn im Restaurant. Wenn sich etwas ändert, aktualisieren Sie es im Admin-Bereich.",
    secondText:
      "Sie müssen nicht jedes Mal einen Designer oder Entwickler kontaktieren, wenn sich ein Preis ändert, ein neues Gericht hinzukommt oder ein Produkt vorübergehend ausgeblendet werden soll. Für ein Restaurant ist das wahrscheinlich einer der größten praktischen Vorteile: Die Speisekarte bleibt lebendig.",
    demo: "DEMO ANSEHEN",
    register: "KOSTENLOS TESTEN",
    navLabel: "Nächste Schritte",
  },

  no: {
    title: "Hvordan Best Place hjelper deg med å starte en QR-meny",
    intro:
      "Best Place er laget slik at en restaurant kan starte med en digital meny uten unødvendig teknisk forvirring. Du legger til informasjon om restauranten, oppretter menyen, fyller inn kategorier og produkter, legger til bilder, priser og beskrivelser. Etterpå får du en QR-kode som leder direkte til menyen din.",
    steps: [
      "Opprett restaurantprofil",
      "Legg til menykategorier",
      "Legg til retter, bilder og beskrivelser",
      "Generer en QR-kode",
      "Støtte i alle faser",
    ],
    firstText:
      "Derfra er prosessen enkel: test menyen på en smarttelefon, skriv ut QR-koden for bord eller bordskilt, og bruk den i restauranten. Når noe endres, oppdaterer du det i administrasjonspanelet.",
    secondText:
      "Du trenger ikke å kontakte en designer eller utvikler hver gang en pris endres, en ny rett legges til, eller et produkt må skjules midlertidig. For en restaurant er dette sannsynligvis en av de største praktiske fordelene: menyen forblir levende.",
    demo: "SE DEMO",
    register: "PRØV GRATIS",
    navLabel: "Neste steg",
  },
};

const stepClasses = [
  "work-list__item--one",
  "work-list__item--two",
  "work-list__item--three",
  "work-list__item--four",
  "work-list__item--five",
];

function normalizeSeoLang(value) {
  const v = String(value || "").trim().toLowerCase();
  return WORK_COPY[v] ? v : "en";
}

export default function SeoWorkSteps({ lang = "en" }) {
  const currentLang = normalizeSeoLang(lang);
  const copy = WORK_COPY[currentLang];

  return (
    <section id="bestplace" className="acquaintance">
      <h2>{copy.title}</h2>

      <p>{copy.intro}</p>

      <section className="work">
        <div className="work__wrapper">
          <div className="work__container">
            <div className="work__picture"></div>
          </div>

          <div className="work-list">
            {copy.steps.map((step, index) => (
              <div
                key={step}
                className={`work-list__item ${stepClasses[index]}`}
              >
                <span
                  className={[
                    "work-list__content",
                    index === 0 ? "work-list__content--top" : "",
                    index === copy.steps.length - 1
                      ? "work-list__content--end"
                      : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  {step}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <p>{copy.firstText}</p>

      <p>{copy.secondText}</p>

      <nav
        className="header--seo__nav-work"
        aria-label={copy.navLabel}
      >
        <ul className="header--seo__navList-work">
          <li className="header--seo__navItem">
            <Link
              to={`/${currentLang}/demo`}
              className="qrArticle__btn"
            >
              {copy.demo}
            </Link>
          </li>

          <li className="header--seo__navItem">
            <Link
              to={`/${currentLang}/register`}
              className="header--seo__button-try-now"
            >
              {copy.register}
            </Link>
          </li>
        </ul>
      </nav>
    </section>
  );
}